// extracted by mini-css-extract-plugin
module.exports = {"more":"MoreButton_more__PcNce"};